module.exports = __webpack_public_path__ + "img/40.cc45b3c8.jpg";